import { BudgetCapping, CompanyPermission, DailyBudgetType } from '../../../../__generated__/graphql'
import { AdgroupBudgetPermissionKey, AdgroupBudgetUserPermissions } from '../../../company/userPermissions.config'

export const isAdgroupBudgetCappingEnabled = (permissions: AdgroupBudgetUserPermissions): boolean =>
  permissions.adgroupBudgetCapping

export const toAdgroupBudgetPermissions = (
  permissions: Pick<CompanyPermission, AdgroupBudgetPermissionKey>
): AdgroupBudgetUserPermissions => ({
  adgroupBudgetCapping: permissions.adgroupBudgetCapping,
  adgroupMonthlyBudgetCapping: permissions.adgroupMonthlyBudgetCapping,
  adgroupOverallBudgetCapping: permissions.adgroupOverallBudgetCapping,
  adgroupOpenBudgetCapping: permissions.adgroupOpenBudgetCapping,
  adgroupOpenDailyBudget: permissions.adgroupOpenDailyBudget,
})

export const isDailyBudgetTypeAllowed = (type: DailyBudgetType, permissions: AdgroupBudgetUserPermissions): boolean => {
  if (type === DailyBudgetType.Open) return permissions.adgroupOpenDailyBudget
  if (type === DailyBudgetType.Auto) return permissions.adgroupBudgetCapping
  return true
}

export const isBudgetCappingTypeAllowed = (type: BudgetCapping, permissions: AdgroupBudgetUserPermissions): boolean => {
  if (!permissions.adgroupBudgetCapping) return false

  switch (type) {
    case BudgetCapping.Monthly:
      return permissions.adgroupMonthlyBudgetCapping
    case BudgetCapping.Overall:
      return permissions.adgroupOverallBudgetCapping
    case BudgetCapping.Open:
      return permissions.adgroupOpenBudgetCapping
    case BudgetCapping.Period:
      return true
    default:
      return true
  }
}

export const filterEnumOptionsByPermission = <T extends string>(
  options: Array<{ value: T; label: string }>,
  isAllowed: (value: T) => boolean,
  currentValue: T | undefined
): Array<{ value: T; label: string }> =>
  options.filter((option) => isAllowed(option.value) || option.value === currentValue)
